import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import RelatedContentCard from './RelatedContentSlider/RelatedContentCard';
import InlineSvg from './InlineSvg';
import { toSnakeCase } from '../helpers/common';

const findSlickSlidesToShow = (slick) => {
  const noBreakPointSlidesToShow = slick.props.slidesToShow || 1;
  if (!slick.state.breakpoint) {
    return noBreakPointSlidesToShow;
  }
  const responsive = slick.props.responsive.find(
    ({ breakpoint }) => breakpoint === slick.state.breakpoint
  );
  if (!responsive) {
    return noBreakPointSlidesToShow;
  }
  return responsive.settings.slidesToShow || noBreakPointSlidesToShow;
};

const RelatedContentSlider = (props) => {
  const sliderRef = useRef(null);
  const { anchorTagLinkText, heading, tiles } = props;
  const [isRendered, setIsRendered] = useState(false);
  const [beginningOfSlide, setBeginningOfSlide] = useState(true);
  const [endOfSlide, setEndOfSlide] = useState(false);
  const sliderSettings = {
    arrows: false,
    slidesToScroll: 1,
    infinite: false,
    variableWidth: true,
    afterChange(current) {
      if (!sliderRef.current) {
        return;
      }
      setBeginningOfSlide(current === 0);
      const slidesToShow = findSlickSlidesToShow(sliderRef.current);
      setEndOfSlide(
        current === sliderRef.current.props.children.length - slidesToShow
      );
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          waitForAnimate: false,
          swipeToSlide: true,
          variableWidth: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          variableWidth: true,
          slidesToShow: undefined,
        },
      },
    ],
  };

  useEffect(() => {
    setIsRendered(true);
  }, []);

  return (
    <section id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`} className="related-content-slider__root">
      <div className="related-content-slider__grid-container">
        <div className="ui container related-content-slider__container_outer">
          <div className="grid-wrapper">
            <div className="related-content-slider__container">
              <h2 className="heading-one related-content-slider__heading">
                {heading}
              </h2>
              <div
                className={classNames('related-content-slider__controls', {
                  'related-content-slider__hideOnDesktop':
                    tiles && tiles.length <= 3,
                })}
              >
                <button
                  onClick={() => {
                    if (sliderRef.current) {
                      sliderRef.current.slickPrev();
                    }
                  }}
                  className={classNames('related-content-slider__leftControl', {
                    'related-content-slider__disabled': beginningOfSlide,
                  })}
                >
                  <InlineSvg
                    name="arrow-right-open"
                    className="related-content-slider__linkArrow"
                  />
                </button>
                <button
                  onClick={() => {
                    if (endOfSlide) {
                      return;
                    }
                    if (sliderRef.current) {
                      sliderRef.current.slickNext();
                    }
                  }}
                  className={classNames(
                    'related-content-slider__rightControl',
                    {
                      'related-content-slider__disabled': endOfSlide,
                    }
                  )}
                >
                  <InlineSvg
                    name="arrow-right-open"
                    className="related-content-slider__linkArrow"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="related-content-slider__grid-wrapper">
            <div className="related-content-slider__tiles">
              {isRendered ? (
                <Slider ref={sliderRef} {...sliderSettings}>
                  {tiles &&
                    tiles.map((tile, i) => {
                      if (!tile || !tile.title) {
                        return null;
                      }

                      return (
                        <RelatedContentCard
                          key={tile.id}
                          number={i}
                          resource={tile}
                          sliderRef={sliderRef}
                        />
                      );
                    })}
                </Slider>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RelatedContentSlider;
